import { Navigate } from "react-router-dom"
import { IProps } from "./types/IProps"
import { useAppSelector } from "../../hooks/store-hooks"
import { useLocalStorageService } from "../../../use-cases/local-storage"
import { useAuthService } from "../../../use-cases/auth"
import { useEffect, useRef, useState } from "react"

export const PrivateRoute = (props: IProps) => {
  const isValid = useAppSelector((state) => state.auth.isValid)
  const token = useAppSelector((state) => state.auth.token)
  const { getItem } = useLocalStorageService()
  const { setupSession } = useAuthService()
  const [isInitializing, setIsInitializing] = useState(true)
  const hasTriedRestore = useRef(false)

  useEffect(() => {
    const tokenStorage = getItem({
      key: 'ACCESS_TOKEN'
    })

    if (isValid && token && token !== 'not_valid' && token !== '') {
      setIsInitializing(false)
      return
    }

    if (tokenStorage && tokenStorage !== '' && (!token || token === 'not_valid')) {
      if (!hasTriedRestore.current) {
        hasTriedRestore.current = true
        setupSession().finally(() => {
          setIsInitializing(false)
        })
        return
      }
    }

    setIsInitializing(false)
  }, [token, isValid, getItem, setupSession])

  const tokenFromStorage = getItem({ key: 'ACCESS_TOKEN' })

  const tokenIsStillValidInRedux = isValid && token && token !== '' && token !== 'not_valid'
  if (isInitializing && tokenFromStorage && tokenFromStorage !== '' && tokenIsStillValidInRedux) {
    return <>{props.children}</>
  }

  const hasValidToken = (isValid && token && token !== '' && token !== 'not_valid') || (tokenFromStorage && tokenFromStorage !== '')

  return (
    <>
      {
        hasValidToken ? (
          <>
            {props.children}
          </>
        ) : <Navigate to="/auth/login" />
      }
    </>
  )
}